(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["button"] && !Shopify.designMode) return;
  try {
    // Smart Button Loading Spinner functionality
  const CUSTOMIZER_LAST_TARGET_URL_KEY = 'customizer:lastTargetUrl';
  const CUSTOMIZER_SHARED_LAST_TARGET_URL_KEY = 'customizer:lastTargetUrlShared';

  function normalizeCustomizerButtonHref(href) {
    if (!href) return href;

    try {
      const url = new URL(href, window.location.origin);
      if (!url.pathname.includes('/pages/customizer')) return href;

      if (url.pathname === '/pages/customizer') {
        url.pathname = '/pages/customizer/';
      }

      const hashMatch = (url.hash || '').match(/^#\/([^/?#]+)\/(step[123])(?:[?#].*)?$/);
      if (hashMatch) {
        if (!url.searchParams.get('variant')) {
          url.searchParams.set('variant', hashMatch[1]);
        }
        if (!url.searchParams.get('step')) {
          url.searchParams.set('step', hashMatch[2]);
        }
      } else {
        const variant = url.searchParams.get('variant');
        const step = url.searchParams.get('step') || 'step1';
        if (variant && /^step[123]$/.test(step)) {
          url.hash = `#/${variant}/${step}`;
        }
      }

      return url.toString();
    } catch (error) {
      return href;
    }
  }

  function prepareCustomizerNavigation(button) {
    const href = button.getAttribute('href');
    const normalizedHref = normalizeCustomizerButtonHref(href);

    if (normalizedHref && normalizedHref !== href) {
      button.setAttribute('href', normalizedHref);
    }

    if (normalizedHref && normalizedHref.includes('/pages/customizer')) {
      const targetUrl = new URL(normalizedHref, window.location.origin).toString();
      try {
        sessionStorage.setItem(CUSTOMIZER_LAST_TARGET_URL_KEY, targetUrl);
      } catch (error) {
        // Ignore storage failures here. The Customizer app has its own fallback.
      }
      try {
        // sessionStorage stays in this tab; this copy also helps when the
        // customizer opens in a new tab. The Customizer app only uses it for 2 hours.
        localStorage.setItem(
          CUSTOMIZER_SHARED_LAST_TARGET_URL_KEY,
          JSON.stringify({ url: targetUrl, at: Date.now() })
        );
      } catch (error) {
        // Ignore storage failures here. The Customizer app has its own fallback.
      }
    }

    return normalizedHref;
  }

  function handleButtonClick(event) {
    const button = event.target.closest('.button-with-spinner');
    if (!button) return;
    
    // Don't add spinner to disabled buttons
    if (button.hasAttribute('aria-disabled') || button.hasAttribute('disabled')) {
      return;
    }
    
    // Handle JavaScript buttons (now <a> elements with data-custom-js)
    if (button.classList.contains('js-button') || button.hasAttribute('data-custom-js')) {
      handleJavaScriptButton(button, event);
      return;
    }
    
    // Check if this is a real navigation or requires loading state
    const href = prepareCustomizerNavigation(button) || button.getAttribute('href');
    const target = button.getAttribute('target');
    
    // Only show loading for:
    // 1. External links that open in same window
    // 2. Internal navigation (not anchors)
    // 3. Form submissions
    const shouldShowLoading = (
      href && 
      href !== '#' && 
      !href.startsWith('#') && 
      !href.startsWith('mailto:') && 
      !href.startsWith('tel:') &&
      target !== '_blank'
    );
    
    if (!shouldShowLoading) {
      return;
    }
    
    // Add loading state
    button.classList.add('loading');
    button.setAttribute('aria-busy', 'true');
    
    // Shorter fallback timeout (3 seconds instead of 10)
    const fallbackTimeout = setTimeout(() => {
      resetButtonLoading(button);
    }, 3000);
    
    // Store timeout ID for cleanup
    button.dataset.loadingTimeout = fallbackTimeout;
  }
  
  function handleJavaScriptButton(button, event) {
    // Prevent default button behavior
    event.preventDefault();
    
    const customJs = button.getAttribute('data-custom-js');
    if (!customJs) {
      console.warn('JavaScript button clicked but no custom JavaScript found');
      return;
    }
    
    // Add loading state for brief visual feedback
    button.classList.add('loading');
    button.setAttribute('aria-busy', 'true');
    
    try {
      // Execute the custom JavaScript
      const func = new Function(customJs);
      func();
      
      // Brief loading state to show button was clicked
      setTimeout(() => {
        resetButtonLoading(button);
      }, 500);
      
    } catch (error) {
      console.error('Error executing custom JavaScript:', error);
      console.error('JavaScript code:', customJs);
      
      // Reset loading state immediately on error
      resetButtonLoading(button);
      
      // Optional: Show user-friendly error
      if (window.console && console.error) {
        alert('Error executing button JavaScript. Check console for details.');
      }
    }
  }
  
  function resetButtonLoading(button) {
    if (!button) return;
    
    button.classList.remove('loading');
    button.removeAttribute('aria-busy');
    
    // Clear timeout if exists
    if (button.dataset.loadingTimeout) {
      clearTimeout(button.dataset.loadingTimeout);
      delete button.dataset.loadingTimeout;
    }
  }
  
  function resetAllButtons() {
    const loadingButtons = document.querySelectorAll('.button-with-spinner.loading');
    loadingButtons.forEach(resetButtonLoading);
  }
  
  // Event-based resets for better UX
  function setupEventListeners() {
    // Use event delegation for button clicks
    document.addEventListener('click', handleButtonClick);
    
    // Reset on page show (back/forward navigation)
    window.addEventListener('pageshow', resetAllButtons);
    
    // Reset on DOM ready
    document.addEventListener('DOMContentLoaded', resetAllButtons);
    
    // Reset on focus (when user returns to tab)
    window.addEventListener('focus', resetAllButtons);
    
    // Reset on visibility change (tab becomes visible)
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        resetAllButtons();
      }
    });
    
    // Reset on before unload (page is leaving)
    window.addEventListener('beforeunload', resetAllButtons);
  }
  
  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupEventListeners);
  } else {
    setupEventListeners();
  }

  // Sticky button functionality
  const STICKY_INTERSECTION_THRESHOLD = 0.05;

  function createFloatingClone(sourceButton, blockId) {
    const floatingButton = sourceButton.cloneNode(true);
    floatingButton.removeAttribute('id');
    floatingButton.removeAttribute('data-stick-when-hidden');
    floatingButton.removeAttribute('data-block-id');
    floatingButton.classList.add('button-sticky-floating');
    floatingButton.setAttribute('data-sticky-clone', blockId);

    document.body.appendChild(floatingButton);
  }

  function syncStickyClones(stickableButtons) {
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    stickableButtons.forEach((sourceButton) => {
      const blockId = sourceButton.dataset.blockId;
      if (!blockId) return;

      const floatingSelector = `[data-sticky-clone="${blockId}"]`;
      const existingFloating = document.querySelector(floatingSelector);

      const rect = sourceButton.getBoundingClientRect();
      const visiblePx = Math.max(0, Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0));
      const ratio = rect.height > 0 ? visiblePx / rect.height : 0;
      const isVisible = ratio >= STICKY_INTERSECTION_THRESHOLD;

      if (isVisible) {
        if (existingFloating) existingFloating.remove();
        return;
      }

      if (!existingFloating) {
        createFloatingClone(sourceButton, blockId);
      }
    });
  }

  function teardownStickyScrollSync() {
    if (!window.__stickyButtonScrollHandler) return;

    window.removeEventListener('scroll', window.__stickyButtonScrollHandler);
    window.removeEventListener('resize', window.__stickyButtonScrollHandler);
    window.__stickyButtonScrollHandler = null;
  }

  function setupStickyScrollSync(stickableButtons) {
    teardownStickyScrollSync();

    let ticking = false;
    const handler = () => {
      if (ticking) return;
      ticking = true;

      requestAnimationFrame(() => {
        ticking = false;
        syncStickyClones(stickableButtons);
      });
    };

    window.__stickyButtonScrollHandler = handler;
    window.addEventListener('scroll', handler, { passive: true });
    window.addEventListener('resize', handler, { passive: true });
  }

  function setupStickyButtons() {
    const stickableButtons = Array.from(document.querySelectorAll('[data-stick-when-hidden="true"]'));

    // Clean up any orphaned floating buttons
    const activeBlockIds = stickableButtons.map((btn) => btn.dataset.blockId);
    document.querySelectorAll('[data-sticky-clone]').forEach((clone) => {
      if (!activeBlockIds.includes(clone.getAttribute('data-sticky-clone'))) {
        clone.remove();
      }
    });

    if (window.__stickyButtonObserver) {
      window.__stickyButtonObserver.disconnect();
      window.__stickyButtonObserver = null;
    }

    teardownStickyScrollSync();

    if (!stickableButtons.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const sourceButton = entry.target;
        const blockId = sourceButton.dataset.blockId;
        if (!blockId) return;

        const floatingSelector = `[data-sticky-clone="${blockId}"]`;
        const existingFloating = document.querySelector(floatingSelector);

        if (entry.isIntersecting) {
          if (existingFloating) existingFloating.remove();
          return;
        }

        if (existingFloating) return;

        createFloatingClone(sourceButton, blockId);
      });
    }, { threshold: STICKY_INTERSECTION_THRESHOLD });

    stickableButtons.forEach((button) => observer.observe(button));
    window.__stickyButtonObserver = observer;

    setupStickyScrollSync(stickableButtons);
    syncStickyClones(stickableButtons);
  }

  function initStickyButtons() {
    setupStickyButtons();
  }

  function teardownStickyButtons() {
    if (window.__stickyButtonObserver) {
      window.__stickyButtonObserver.disconnect();
      window.__stickyButtonObserver = null;
    }

    teardownStickyScrollSync();

    document.querySelectorAll('[data-sticky-clone]').forEach((clone) => clone.remove());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyButtons);
  } else {
    initStickyButtons();
  }

  document.addEventListener('shopify:section:load', initStickyButtons);
  document.addEventListener('shopify:section:unload', teardownStickyButtons);
  } catch(e) { console.error(e); }
})();

})();
